<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M13.64979375,6.19C13.30979375,6.19,13.00979375,6.3,12.76979375,6.48C12.59979375,6,12.08979375,5.64,11.47979375,5.64C11.06979375,5.64,10.69979375,5.8,10.44979375,6.06C10.21979375,5.69,9.77979375,5.43,9.25979375,5.43C8.68979375,5.43,8.20979375,5.74,8.00979375,6.17C8.00979375,6.17,7.99979375,5.55,7.99979375,5.55C7.99979375,5.55,7.99979375,1.5,7.99979375,1.5C7.99979375,0.67,7.32979375,0,6.49979375,0C5.66979375,0,4.99979375,0.67,4.99979375,1.5C4.99979375,1.5,4.99979375,8.11,4.99979375,8.11C4.41979375,7.7,3.44979375,6.9,2.51979375,6.81C0.95978875,6.67,0.69978975,7.88,1.27978975,8.13C2.81979375,8.8,4.26979375,10.81,4.97979375,12.08C5.88979375,14.05,6.06979375,16,9.85979375,16C11.94979375,16,13.28979375,15.39,14.07979375,13.88C14.71979375,12.64,14.99979375,10.79,14.99979375,8.17C14.99979375,8.17,14.99979375,7.38,14.99979375,7.38C14.99979375,6.73,14.39979375,6.19,13.64979375,6.19C13.64979375,6.19,13.64979375,6.19,13.64979375,6.19Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'HandUp',
} as DefineComponent
</script>
